import momentTz from 'moment-timezone';
import { registerDecorator, ValidationOptions, ValidationArguments } from 'class-validator';

import { ScheduleBlock } from '../ScheduleNodeDef';

export function IsStartBeforeEndDateTime(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: 'isStartBeforeEndDateTime',
      constraints: [],
      options: validationOptions,
      propertyName: propertyName,
      target: object.constructor,
      validator: {
        validate(currentPropertyValue: string, args: ValidationArguments) {
          const exception = args.object as ScheduleBlock;

          return isStartDateBeforeEndDate(currentPropertyValue, exception);
        },
        defaultMessage() {
          return 'Start date/time comes after end date/time';
        },
      },
    });
  };
}

export function isStartDateBeforeEndDate(start: string, exception: ScheduleBlock) {
  if (!start || !exception.end) {
    return true;
  }

  const startDate = momentTz(start, 'h:mma');
  const endDate = momentTz(exception.end, 'h:mma');

  return startDate.isSameOrBefore(endDate);
}
